// Stewardship (PRE-2287) — steward review of dedup clusters whose merge left
// unresolved field conflicts, and manual resolution with MANUAL provenance.
export const GET_STEWARD_CONFLICTS_REQUEST = "GET_STEWARD_CONFLICTS_REQUEST";
export const GET_STEWARD_CONFLICTS_SUCCESS = "GET_STEWARD_CONFLICTS_SUCCESS";
export const GET_STEWARD_CONFLICTS_FAILURE = "GET_STEWARD_CONFLICTS_FAILURE";

export const STEWARD_RESOLVE_REQUEST = "STEWARD_RESOLVE_REQUEST";
export const STEWARD_RESOLVE_SUCCESS = "STEWARD_RESOLVE_SUCCESS";
export const STEWARD_RESOLVE_FAILURE = "STEWARD_RESOLVE_FAILURE";

// Conflicts come from the merge preview (the backend returns fieldConflicts alongside
// the previewed record), so the modal shows exactly what the real merge leaves undecided.
export const getStewardConflictsRequest = (duplicateSetId, duplicateSetVersion, groupId) => ({
    type: GET_STEWARD_CONFLICTS_REQUEST,
    params: { duplicateSetId, duplicateSetVersion, groupId },
});
export const getStewardConflictsSuccess = (fieldConflicts) => ({ type: GET_STEWARD_CONFLICTS_SUCCESS, payload: fieldConflicts });
export const getStewardConflictsFailure = (error) => ({ type: GET_STEWARD_CONFLICTS_FAILURE, payload: error });

// POST /dataobjects/steward/resolve
export const stewardResolveRequest = ({ duplicateSetId, duplicateSetVersion, groupId, dataObjectId, resolutions, reason }) => ({
    type: STEWARD_RESOLVE_REQUEST,
    params: { duplicateSetId, duplicateSetVersion, groupId, dataObjectId, resolutions, reason },
});
export const stewardResolveSuccess = (result) => ({ type: STEWARD_RESOLVE_SUCCESS, payload: result });
export const stewardResolveFailure = (error) => ({ type: STEWARD_RESOLVE_FAILURE, payload: error });
